// ALL cross-feature component imports go HERE and ONLY here.
// Feature components should NEVER be imported directly from other features.
// Use PageName enum + NavigationService for cross-feature navigation.
import { registerComponent } from './component-registry';
import { PageName } from './navigation.service';

registerComponent(
  PageName.ContactPageComponent,
  () => import('@omni/components/contact/contact-page/contact-page').then(m => m.ContactPageComponent)
);

registerComponent(
  PageName.SuperTargetListComponent,
  () => import('@omni/components/super-target/super-target-list/super-target-list').then(m => m.SuperTargetListComponent)
);

registerComponent(
  PageName.ActivitiesDetailsPaneComponent,
  () => import('@omni/components/activity/activities-details-pane/activities-details-pane').then(m => m.ActivitiesDetailsPaneComponent)
);

registerComponent(
  PageName.AccountPageComponent,
  () => import('@omni/components/account/account-page/account-page').then(m => m.AccountPageComponent)
);

registerComponent(
  PageName.ContactDetailsComponent,
  () => import('@omni/components/contact/contact-details/contact-details').then(m => m.ContactDetailsComponent)
);

registerComponent(
  PageName.AccountDetailsComponent,
  () => import('@omni/components/account/account-details/account-details').then(m => m.AccountDetailsComponent)
);

registerComponent(
  PageName.PresentationPageComponent,
  () => import('@omni/pages/presentation/presentation').then(m => m.PresentationPageComponent)
);

registerComponent(
  PageName.NothingSelectedView,
  () => import('@omni/components/shared/nothing-selected-view/nothing-selected-view').then(m => m.NothingSelectedView)
);

registerComponent(
  PageName.ExternalAppFrameComponent,
  () => import('@omni/components/ext-app-frame/ext-app-frame').then(m => m.ExternalAppFrameComponent)
);

registerComponent(
  PageName.NewActivityComponent,
  () => import('@omni/components/activity/new-activity/new-activity').then(m => m.NewActivityComponent)
);

registerComponent(
  PageName.CustomerInsightComponent,
  () => import('@omni/components/contact/customer-insight/customer-insight').then(m => m.CustomerInsightComponent)
);

registerComponent(
  PageName.InisghtsPlusComponent,
  () => import('@omni/components/inisghts-plus/insights-plus').then(m => m.InsightsPlusComponent)
);

registerComponent(
  PageName.GeneralInsightsPlusComponent,
  () => import('@omni/components/general-insights-plus/general-insights-plus').then(m => m.GeneralInsightsPlusComponent)
);

registerComponent(
  PageName.CaseManagementDetailComponent,
  () => import('@omni/components/case-management/case-management-detail/case-management-detail').then(m => m.CaseManagementDetailComponent)
);

registerComponent(
  PageName.PhoneCallDetailsComponent,
  () => import('@omni/components/phonecall/phone-call-details/phone-call-details').then(m => m.PhoneCallDetailsComponent)
);

registerComponent(
  PageName.StoreCheckDetailsComponent,
  () => import('@omni/components/activity/store-check-activity/store-check-details').then(m => m.StoreCheckDetailsComponent)
);

registerComponent(
  PageName.FollowUpActionDetailComponent,
  () => import('@omni/components/activity/follow-up-action-detail/follow-up-action-detail').then(m => m.FollowUpActionDetailComponent)
);

registerComponent(
  PageName.OpportunityQuoteDetailsComponent,
  () => import('@omni/components/opportunity-management/opportunity-quote-details/opportunity-quote-details').then(m => m.OpportunityQuoteDetailsComponent)
);

registerComponent(
  PageName.ContactConsentCaptureComponent,
  () => import('@omni/components/contact/contact-consent-capture/contact-consent-capture').then(m => m.ContactConsentCaptureComponent)
);

registerComponent(
  PageName.OrderDetailsComponent,
  () => import('@omni/components/order-management/order-details/order-details').then(m => m.OrderDetailsComponent)
);

registerComponent(
  PageName.SurgeryOrderDetailsComponent,
  () => import('@omni/components/surgery-order/surgery-order-details/surgery-order-details').then(m => m.SurgeryOrderDetailsComponent)
);

registerComponent(
  PageName.EmailDetailsPageComponent,
  () => import('@omni/components/activity/email-activity-detail/email-activity-detail').then(m => m.EmailActivityDetailComponent)
);

registerComponent(
  PageName.NewSampleActivityComponent,
  () => import('@omni/components/activity/new-sample-activity/new-sample-activity').then(m => m.NewSampleActivityComponent)
);

registerComponent(
  PageName.ScientificPlanFollowUpTask,
  () => import('@omni/components/activity/scientific-activity/scientific-plan-task/scientific-plan-task').then(m => m.ScientificPlanFollowUpTask)
);

registerComponent(
  PageName.OpportunityManagementPage,
  () => import('@omni/components/opportunity-management/opportunity-management-page/opportunity-management-page').then(m => m.OpportunityManagementPageComponent)
);

registerComponent(
  PageName.SurveyPageComponent,
  () => import('@omni/components/survey/survey-page/survey-page').then(m => m.SurveyPageComponent)
);

registerComponent(
  PageName.SurveyDetailsComponent,
  () => import('@omni/components/survey/survey-details/survey-details').then(m => m.SurveyDetailsComponent)
);

registerComponent(
  PageName.DynamicFormComponent,
  () => import('@omni/components/shared/ind-dynamic-form/ind-dynamic-form').then(m => m.DynamicFormComponent)
);

registerComponent(
  PageName.NewQuoteComponent,
  () => import('@omni/components/quote/new-quote/new-quote.component').then(m => m.NewQuoteComponent)
);

registerComponent(
  PageName.ProcedureTrackerDetailsComponent,
  () => import('@omni/components/surgery-order/procedure-tracker-details/procedure-tracker-details').then(m => m.ProcedureTrackerDetailsComponent)
);

registerComponent(
  PageName.SetBookingActivityDetailsComponent,
  () => import('@omni/components/activity/set-booking-activity-detail/set-booking-activity-detail').then(m => m.SetBookingActivityDetailsComponent)
);

registerComponent(
  PageName.TimeOffDetailsComponent,
  () => import('@omni/components/time-off/time-off-details/time-off-details').then(m => m.TimeOffDetailsComponent)
);

registerComponent(
  PageName.ScientificActivityPage,
  () => import('@omni/components/activity/scientific-activity/scientific-activity-page/scientific-activity-page').then(m => m.ScientificActivityPage)
);

registerComponent(
  PageName.CoachingComponent,
  () => import('@omni/components/coaching/coaching-home/coaching-home').then(m => m.CoachingComponent)
);

registerComponent(
  PageName.CustomerCallPlanPage,
  () => import('@omni/components/customer-call-plans/customer-call-plan-page/customer-call-plan-page').then(m => m.CustomerCallPlanPage)
);

registerComponent(
  PageName.EventsToolPageComponent,
  () => import('@omni/components/events-tool/event-tool-page/events-tools-page').then(m => m.EventsToolPageComponent)
);

registerComponent(
  PageName.FieldMaterialManagementPageComponent,
  () => import('@omni/components/field-material-management/field-material-management-page/field-material-management-page').then(m => m.FieldMaterialManagementPageComponent)
);

registerComponent(
  PageName.MarketScanPageComponent,
  () => import('@omni/components/market-scan/market-scan-page/market-scan-page').then(m => m.MarketScanPageComponent)
);

registerComponent(
  PageName.OrderManagementPageComponent,
  () => import('@omni/components/order-management/order-management-page/order-management-page').then(m => m.OrderManagementPageComponent)
);

registerComponent(
  PageName.PharmacovigilancePage,
  () => import('@omni/components/pharmacovigilance-reporting/page/pharmacovigilance-page').then(m => m.PharmacovigilanceComponent)
);

registerComponent(
  PageName.PharmacovigilanceDetail,
  () => import('@omni/components/pharmacovigilance-reporting/detail/pharmacovigilance-detail').then(m => m.PharmacovigilanceDetail)
);

registerComponent(
  PageName.OrderManagementToolPage,
  () => import('@omni/components/order-capture/order-management-tool/order-management-tool.page').then(m => m.OrderManagementToolPageComponent)
);

registerComponent(
  PageName.VoiceNotesPageComponent,
  () => import('@omni/components/voice-notes/voice-notes-page/voice-notes-page').then(m => m.VoiceNotesPageComponent)
);

registerComponent(
  PageName.VoiceNoteDetailsComponent,
  () => import('@omni/components/voice-notes/voice-note-details/voice-note-details').then(m => m.VoiceNoteDetailsComponent)
);

registerComponent(
  PageName.ResourcePageComponent,
  () => import('@omni/components/resource/resource-page/resource-page').then(m => m.ResourcePageComponent)
);

registerComponent(
  PageName.AllocationComponent,
  () => import('@omni/components/sample/allocation-page/allocation-page').then(m => m.AllocationComponent)
);

registerComponent(
  PageName.TimeOffComponent,
  () => import('@omni/components/time-off/time-off-home/time-off-home').then(m => m.TimeOffComponent)
);

registerComponent(
  PageName.AccountManagementPageComponent,
  () => import('@omni/pages/account-management-page/account-management-page').then(m => m.AccountManagementPageComponent)
);

registerComponent(
  PageName.CaseManagementHomePage,
  () => import('@omni/pages/case-management-home/case-management-home').then(m => m.CaseManagementHomePage)
);

registerComponent(
  PageName.MarketingPlanManagementPageComponent,
  () => import('@omni/pages/marketing-plan-page/marketing-plan-page').then(m => m.MarketingPlanManagementPageComponent)
);

registerComponent(
  PageName.QuotePageComponent,
  () => import('@omni/pages/quote-page/quote-page').then(m => m.QuotePageComponent)
);

registerComponent(
  PageName.SchedulerPageComponent,
  () => import('@omni/components/scheduler/scheduler-page/scheduler-page.component').then(m => m.SchedulerPageComponent)
);

registerComponent(
  PageName.CoachingDetailsComponent,
  () => import('@omni/components/coaching/coaching-details/coaching-details').then(m => m.CoachingDetailsComponent)
);

registerComponent(
  PageName.OpportunitySelectionPage,
  () => import('@omni/components/opportunity-management/opportunity-selection-master-page/opportunity-selection-master-page').then(m => m.OpportunitySelectionPageComponent)
);

registerComponent(
  PageName.MainToolTemplateComponent,
  () => import('@omni/components/shared/main-tool-template/main-tool-template').then(m => m.MainToolTemplateComponent)
);

registerComponent(
  PageName.MarketScanEditPageComponent,
  () => import('@omni/components/market-scan/market-scan-edit-page/market-scan-edit-page').then(m => m.MarketScanEditPageComponent)
);

registerComponent(
  PageName.SurgeryOrderContractDetailsComponent,
  () => import('@omni/components/surgery-order/surgery-order-contract-details/surgery-order-contract-details.component').then(m => m.SurgeryOrderContractDetailsComponent)
);

registerComponent(
  PageName.SurgeryOrderContractComponent,
  () => import('@omni/components/surgery-order/surgery-order-contract/surgery-order-contract.component').then(m => m.SurgeryOrderContractComponent)
);

registerComponent(
  PageName.ConsentDetailsComponent,
  () => import('@omni/components/contact/consent-details/consent-details').then(m => m.ConsentDetailsComponent)
);

registerComponent(
  PageName.ConsentTermDetailsComponent,
  () => import('@omni/components/contact/consent-term-details/consent-term-details').then(m => m.ConsentTermDetailsComponent)
);

registerComponent(
  PageName.ProcedureTrackerComponent,
  () => import('@omni/components/surgery-order/procedure-tracker/procedure-tracker').then(m => m.ProcedureTrackerComponent)
);

registerComponent(
  PageName.LocationComponent,
  () => import('@omni/components/location/location').then(m => m.LocationComponent)
);

registerComponent(
  PageName.CaptureSignatureMeetingComponent,
  () => import('@omni/components/capture-signature-meeting/capture-signature-meeting').then(m => m.CaptureSignatureMeetingComponent)
);

registerComponent(
  PageName.CalendarInviteTemplatePageComponent,
  () => import('@omni/components/calendar-invite-template/calendar-invite-template-page/calendar-invite-template-page').then(m => m.CalendarInviteTemplatePageComponent)
);

registerComponent(
  PageName.MorePlansInsightsComponent,
  () => import('@omni/components/customer-xperiences/insights/more-plans-insights/more-plans-insights').then(m => m.MorePlansInsightsComponent)
);

registerComponent(
  PageName.OpportunityDetailsComponent,
  () => import('@omni/components/opportunity-management/opportunity-details/opportunity-details').then(m => m.OpportunityDetailsComponent)
);

registerComponent(
  PageName.QuoteDetailsComponent,
  () => import('@omni/components/quote/quote-details/quote-details.component').then(m => m.QuoteDetailsComponent)
);

registerComponent(
  PageName.TrendingAccountsComponent,
  () => import('@omni/components/trending-accounts/trending-accounts').then(m => m.TrendingAccountsComponent)
);

registerComponent(
  PageName.ResourceShareHistoryComponent,
  () => import('@omni/components/resource/resource-share-history/resource-share-history').then(m => m.ResourceShareHistoryComponent)
);

registerComponent(
  PageName.ChildUsersPageComponent,
  () => import('@omni/components/child-users-page/child-users-page').then(m => m.ChildUsersPageComponent)
);

registerComponent(
  PageName.CaptureAllocationOrderComponent,
  () => import('@omni/components/capture-allocation-order/capture-allocation-order').then(m => m.CaptureAllocationOrderComponent)
);

registerComponent(
  PageName.IOMultiSelect,
  () => import('@omni/components/io-component/io-multiselect/io-multiselect').then(m => m.IOMultiSelect)
);

registerComponent(
  PageName.ResourceInteractionDetailComponent,
  () => import('@omni/components/resource-interaction-detail/resource-interaction-detail').then(m => m.ResourceInteractionDetailComponent)
);

registerComponent(
  PageName.PdfPreviewComponent,
  () => import('@omni/components/pdf-preview/pdf-preview').then(m => m.PdfPreviewComponent)
);

registerComponent(
  PageName.EventDetailsPageComponent,
  () => import('@omni/components/events-tool/event-details/event-details').then(m => m.EventDetailsComponent)
);

registerComponent(
  PageName.AccountPlanDetailsComponent,
  () => import('@omni/components/account-management/account-plan-details/account-plan-details').then(m => m.AccountPlanDetails)
);

registerComponent(
  PageName.AffiliationExplorerComponent,
  () => import('@omni/components/shared/affiliation-explorer/affiliation-explorer').then(m => m.AffiliationExplorerComponent)
);

registerComponent(
  PageName.AssetDetailsComponent,
  () => import('@omni/components/field-material-management/asset-details/asset-details').then(m => m.AssetDetailsComponent)
);

registerComponent(
  PageName.AccountPlanActivities,
  () => import('@omni/components/account-management/account-plan-activities/account-plan-activities').then(m => m.AccountPlanActivities)
);

registerComponent(
  PageName.ContactNewAddressComponent,
  () => import('@omni/components/contact/contact-change/contact-address/contact-address-add').then(m => m.ContactNewAddressComponent)
);

registerComponent(
  PageName.GoAppActivitiesPageComponent,
  () => import('@omni/pages/go-app-activities-page/go-app-activities-page.component').then(m => m.GoAppActivitiesPageComponent)
);

registerComponent(
  PageName.NotificationDetailsComponent,
  () => import('@omni/components/notification/notification-details/notification-details').then(m => m.NotificationDetailsComponent)
);

registerComponent(
  PageName.AccountTimelinePageComponent,
  () => import('@omni/components/account/account-timeline-page/account-timeline-page.component').then(m => m.AccountTimelinePageComponent)
);

registerComponent(
  PageName.AllocationShipmentDetailsComponent,
  () => import('@omni/components/sample/allocation-shipment-details/allocation-shipment-details').then(m => m.AllocationShipmentDetailsComponent)
);

registerComponent(
  PageName.PresentationPreviewComponent,
  () => import('@omni/components/presentation/presentation-preview/presentation-preview').then(m => m.PresentationPreviewComponent)
);

registerComponent(
  PageName.CustomerRelationshipComponent,
  () => import('@omni/components/contact/customer-insight/customer-relationship/customer-relationship').then(m => m.CustomerRelationshipComponent)
);

registerComponent(
  PageName.CustomerJourneyComponent,
  () => import('@omni/components/contact/customer-insight/customer-journey/customer-journey').then(m => m.CustomerJourneyComponent)
);

registerComponent(
  PageName.CustomerInterestComponent,
  () => import('@omni/components/contact/customer-insight/customer-interest/customer-interest').then(m => m.CustomerInterestComponent)
);

registerComponent(
  PageName.TerritoryManagementDetailsComponent,
  () => import('@omni/components/territory-management/territory-management-details/territory-management-details').then(m => m.TerritoryManagementDetailsComponent)
);

registerComponent(
  PageName.NewManageListComponent,
  () => import('@omni/components/territory-management/new-manage-list/new-manage-list.component').then(m => m.NewManageListComponent)
);

registerComponent(
  PageName.ScientificActivityDetail,
  () => import('@omni/components/activity/scientific-activity/scientific-activity-detail/scientific-activity-detail').then(m => m.ScientificActivityDetail)
);

registerComponent(
  PageName.SchedulerPopoverComponent,
  () => import('@omni/components/popover/scheduler-popover/scheduler-popover').then(m => m.SchedulerPopoverComponent)
);

registerComponent(
  PageName.ParticipantListComponent,
  () => import('@omni/components/resource/participant-list/participant-list').then(m => m.ParticipantListComponent)
);

registerComponent(
  PageName.AboutDetailsComponent,
  () => import('@omni/components/app-settings/about-page/about-details/about-details').then(m => m.AboutDetailsComponent)
);

registerComponent(
  PageName.AboutSettingsComponent,
  () => import('@omni/components/app-settings/about-page/about-page').then(m => m.AboutPageComponent)
);

registerComponent(
  PageName.AccountCrDetailsComponent,
  () => import('@omni/components/mdm/account/account-cr-details/account-cr-details').then(m => m.AccountCrDetailsComponent)
);

registerComponent(
  PageName.AccountObjectiveDetailsComponent,
  () => import('@omni/components/account-management/account-objective-details/account-objective-details').then(m => m.AccountObjectiveDetails)
);

registerComponent(
  PageName.AccountPlanOpportunityListComponent,
  () => import('@omni/components/account-management/account-plan-opportunity-list/account-plan-opportunity-list').then(m => m.AccountPlanOpportunityListComponent)
);

registerComponent(
  PageName.AppSettingsDetailsComponent,
  () => import('@omni/components/app-settings/appsettings-details/appsettings-details').then(m => m.AppSettingsDetailsComponent)
);

registerComponent(
  PageName.SettingsOptionListComponent,
  () => import('@omni/components/settings/settings-option-list/settings-option-list.component').then(m => m.SettingsOptionListComponent)
);

registerComponent(
  PageName.AppSettingsRecommendationsComponent,
  () => import('@omni/components/app-settings/app-settings-recommendations/app-settings-recommendations.component').then(m => m.AppSettingsRecommendationsComponent)
);

registerComponent(
  PageName.AppealDetailsComponent,
  () => import('@omni/components/appeal-details/appeal-details.component').then(m => m.AppealDetailsComponent)
);

registerComponent(
  PageName.AssetTransferDetailsComponent,
  () => import('@omni/components/field-material-management/asset-transfer-details/asset-transfer-details').then(m => m.AssetTransferDetailsComponent)
);

registerComponent(
  PageName.CallPlanCustDetailsComponent,
  () => import('@omni/components/call-plans/call-plan-cust-details/call-plan-cust-details').then(m => m.CallPlanCustDetailsComponent)
);

registerComponent(
  PageName.CallPlanDetails,
  () => import('@omni/components/call-plans/call-plan-details/call-plan-details').then(m => m.CallPlanDetails)
);

registerComponent(
  PageName.CaptureCustomerInquireComponent,
  () => import('@omni/components/case-management/capture-customer-inquire/capture-customer-inquire').then(m => m.CaptureCustomerInquireComponent)
);

registerComponent(
  PageName.CaptureEventsComponent,
  () => import('@omni/components/events-tool/capture-events/capture-events').then(m => m.CaptureEventsComponent)
);

registerComponent(
  PageName.CoachingActivitiesComponent,
  () => import('@omni/components/coaching/coaching-activities/coaching-activities').then(m => m.CoachingActivitiesComponent)
);

registerComponent(
  PageName.ContactMedicalInsightComponent,
  () => import('@omni/components/contact/contact-medical-insight/contact-medical-insight').then(m => m.ContactMedicalInsightComponent)
);

registerComponent(
  PageName.ContactOmnichannelEventsComponent,
  () => import('@omni/components/contact/contact-omnichannel-events/contact-omnichannel-events').then(m => m.ContactOmnichannelEventsComponent)
);

registerComponent(
  PageName.ContactOmnichannelOpportunitiesComponent,
  () => import('@omni/components/contact/contact-omnichannel-opportunities/contact-omnichannel-opportunities').then(m => m.ContactOmnichannelOpportunitiesComponent)
);

registerComponent(
  PageName.ContactSentimentHistoryListComponent,
  () => import('@omni/components/contact/contact-sentiment-history-list/contact-sentiment-history-list').then(m => m.ContactSentimentHistoryListComponent)
);

registerComponent(
  PageName.ContactTimelinePageComponent,
  () => import('@omni/components/contact/contact-timeline-page/contact-timeline-page').then(m => m.ContactTimelinePageComponent)
);

registerComponent(
  PageName.CrDetailsComponent,
  () => import('@omni/components/mdm/contact/cr-details/cr-details').then(m => m.CrDetailsComponent)
);

registerComponent(
  PageName.CustomNotificationDetails,
  () => import('@omni/components/custom-notification/custom-notification-details').then(m => m.CustomNotificationDetails)
);

registerComponent(
  PageName.CustomerAvailabilityComponent,
  () => import('@omni/components/contact/customer-availability/customer-availability.component').then(m => m.CustomerAvailabilityComponent)
);

registerComponent(
  PageName.CustomerCallPlanDetails,
  () => import('@omni/components/customer-call-plans/customer-call-plan-details/customer-call-plan-details').then(m => m.CustomerCallPlanDetails)
);

registerComponent(
  PageName.CustomerCallPlanSuggest,
  () => import('@omni/components/customer-call-plans/customer-call-plan-suggest/customer-call-plan-suggest').then(m => m.CustomerCallPlanSuggest)
);

registerComponent(
  PageName.DateFormatsPage,
  () => import('@omni/pages/settings/date-formats-page').then(m => m.DateFormatsPage)
);

registerComponent(
  PageName.EdgeAnalyticsDetailComponent,
  () => import('@omni/components/edge-analytics/edge-analytics-detail/edge-analytics-detail').then(m => m.EdgeAnalyticsDetailComponent)
);

registerComponent(
  PageName.EmailTemplatePageComponent,
  () => import('@omni/components/email/email-template-page/email-template-page').then(m => m.EmailTemplatePageComponent)
);

registerComponent(
  PageName.EmailTemplateDetailsComponent,
  () => import('@omni/components/email/email-template-details/email-template-details').then(m => m.EmailTemplateDetailsComponent)
);

registerComponent(
  PageName.EventAttendiesListComponent,
  () => import('@omni/components/events-tool/event-attendies-list/event-attendies-list.component').then(m => m.EventAttendiesListComponent)
);

registerComponent(
  PageName.EventParticipantComponent,
  () => import('@omni/components/event-participant/event-participant').then(m => m.EventParticipantComponent)
);

registerComponent(
  PageName.ExpensesDetails,
  () => import('@omni/components/account-management/account-plan-expenses/expenses-details').then(m => m.ExpensesDetails)
);

registerComponent(
  PageName.GeneralSettingsComponent,
  () => import('@omni/components/app-settings/general-settings/general-settings').then(m => m.GeneralSettingsComponent)
);

registerComponent(
  PageName.GoAppNotificationPageComponent,
  () => import('@omni/pages/go-app-notification-page/go-app-notification-page').then(m => m.GoAppNotificationPageComponent)
);

registerComponent(
  PageName.GoAppSettingsComponent,
  () => import('@omni/pages/go-app-settings/go-app-settings.component').then(m => m.GoAppSettingsComponent)
);

registerComponent(
  PageName.ImpactDetailsComponent,
  () => import('@omni/components/xperiences/impact-details-pane/impact-details-pane').then(m => m.ImpactDetailsComponent)
);

registerComponent(
  PageName.IndPhotoCaptureViewerComponent,
  () => import('@omni/components/shared/ind-photo-capture-viewer/ind-photo-capture-viewer').then(m => m.IndPhotoCaptureViewerComponent)
);

registerComponent(
  PageName.IndPhotoViewerComponent,
  () => import('@omni/components/shared/ind-photo-viewer/ind-photo-viewer').then(m => m.IndPhotoViewerComponent)
);

registerComponent(
  PageName.IndRightpaneReadonlyComponent,
  () => import('@omni/components/shared/ind-rightpane-readonly/ind-rightpane-readonly').then(m => m.IndRightpaneReadonlyComponent)
);

registerComponent(
  PageName.KOLDetailsComponent,
  () => import('@omni/components/contact/kol-status-details/kol-status-details').then(m => m.KOLStatusDetailsComponent)
);

registerComponent(
  PageName.LanguageSettingsComponent,
  () => import('@omni/components/app-language-settings/language-setting-page/app-language-settings').then(m => m.LanguageSettingsComponent)
);

registerComponent(
  PageName.MainToolTemplateDetailsComponent,
  () => import('@omni/components/shared/main-tool-template-details/main-tool-template-details').then(m => m.MainToolTemplateDetailsComponent)
);

registerComponent(
  PageName.MarketScanDetailsComponent,
  () => import('@omni/components/market-scan/market-scan-details/market-scan-details').then(m => m.MarketScanDetailsComponent)
);

registerComponent(
  PageName.MarketingEmailDetailsComponent,
  () => import('@omni/components/email/marketing-email-details/marketing-email-details').then(m => m.MarketingEmailDetailsComponent)
);

registerComponent(
  PageName.MarketingPlanDetails,
  () => import('@omni/components/marketing-business/marketing-plan-details/marketing-plan-details').then(m => m.MarketingPlanDetails)
);

registerComponent(
  PageName.MeetingSentimentHistoryDetailComponent,
  () => import('@omni/components/activity/meeting-sentiment-history-detail/meeting-sentiment-history-detail').then(m => m.MeetingSentimentHistoryDetailComponent)
);

registerComponent(
  PageName.NewAccountPlanComponent,
  () => import('@omni/components/account-management/new-account-plan/new-account-plan').then(m => m.NewAccountPlanComponent)
);

registerComponent(
  PageName.NewChangeRequestComponent,
  () => import('@omni/components/mdm/new-change-request/new-change-request').then(m => m.NewChangeRequestComponent)
);

registerComponent(
  PageName.NewOpportunityComponent,
  () => import('@omni/components/opportunity-management/new-opportunity/new-opportunity').then(m => m.NewOpportunityComponent)
);

registerComponent(
  PageName.OpportunitiesListComponent,
  () => import('@omni/components/opportunity-management/opportunities-list/opportunities-list').then(m => m.OpportunitiesListComponent)
);

registerComponent(
  PageName.OpportunityCollaboratorsComponent,
  () => import('@omni/components/opportunity-management/opportunity-collaborators/opportunity-collaborators').then(m => m.OpportunityCollaboratorsComponent)
);

registerComponent(
  PageName.OrderAddQuantityComponent,
  () => import('@omni/components/order-management/order-add-quantity/order-add-quantity').then(m => m.OrderAddQuantityComponent)
);

registerComponent(
  PageName.PersonalizedQuickGlanceViewComponent,
  () => import('@omni/components/shared/personalize-quick-glance/personalize-quick-glance').then(m => m.PersonalizeQuickGlanceComponent)
);

registerComponent(
  PageName.PlanProgressReportComponent,
  () => import('@omni/components/account-management/plan-progress-report/plan-progress-report').then(m => m.PlanProgressReport)
);

registerComponent(
  PageName.PresentationDetailComponent,
  () => import('@omni/components/presentation/presentation-detail/presentation-detail').then(m => m.PresentationDetailComponent)
);

registerComponent(
  PageName.PresentationFullscreenComponent,
  () => import('@omni/pages/presentation/presentation-fullscreen').then(m => m.PresentationFullscreenComponent)
);

registerComponent(
  PageName.PresentationMeetingComponent,
  () => import('@omni/pages/presentation/presentation-meeting').then(m => m.PresentationMeetingComponent)
);

registerComponent(
  PageName.QuoteProductsComponent,
  () => import('@omni/components/quote/quote-products/quote-products.component').then(m => m.QuoteProductsComponent)
);

registerComponent(
  PageName.ResourceDetailsComponent,
  () => import('@omni/components/resource/resource-details/resource-details').then(m => m.ResourceDetailsComponent)
);

registerComponent(
  PageName.SectionSpecificComponent,
  () => import('@omni/components/assessment/section-specific/section-specific').then(m => m.SectionSpecificComponent)
);

registerComponent(
  PageName.SurveyListCardviewComponent,
  () => import('@omni/components/survey/survey-list-cardview/survey-list-cardview').then(m => m.SurveyListCardviewComponent)
);

registerComponent(
  PageName.TemplatePreviewComponent,
  () => import('@omni/components/email/template-preview/template-preview').then(m => m.TemplatePreviewComponent)
);

registerComponent(
  PageName.EmailTemplatePageComponent,
  () => import('@omni/components/email/email-template-page/email-template-page').then(m => m.EmailTemplatePageComponent)
);

registerComponent(
  PageName.TerritoryManagementPageComponent,
  () => import('@omni/pages/territory-management-page/territory-management-page.component').then(m => m.TerritoryManagementPageComponent)
);

registerComponent(
  PageName.CustomerAssessComponent,
  () => import('@omni/components/assessment/customer-assess/customer-assess').then(m => m.CustomerAssessComponent)
);

registerComponent(
  PageName.RemoteURLEmailTemplate,
  () => import('@omni/components/activity/email-template/email-template').then(m => m.RemoteURLEmailTemplate)
);

registerComponent(
  PageName.KOLStatusPageComponent,
  () => import('@omni/components/contact/kol-status-page/kol-status-page').then(m => m.KOLStatusPageComponent)
);

registerComponent(
  PageName.MedicalInsightPageComponent,
  () => import('@omni/components/contact/medical-insight-page/medical-insight-page').then(m => m.MedicalInsightPageComponent)
);

registerComponent(
  PageName.MedicalInquiryHomePage,
  () => import('@omni/pages/medical-inquiry-home/medical-inquiry-home').then(m => m.MedicalInquiryHomePage)
);

registerComponent(
  PageName.MedicalInquiryNewComponent,
  () => import('@omni/components/medical-inquiry/medical-inquiry-new/medical-inquiry-new.component').then(m => m.MedicalInquiryNewComponent)
);

registerComponent(
  PageName.MedicalInquiryDetailComponent,
  () => import('@omni/components/medical-inquiry/medical-inquiry-detail/medical-inquiry-detail.component').then(m => m.MedicalInquiryDetailComponent)
);

registerComponent(
  PageName.MedProSearchPageComponent,
  () => import('@omni/components/contact/medpro-search/medpro-search.page').then(m => m.MedProSearchPageComponent)
);

registerComponent(
  PageName.NewSampleDeliveryRequestComponent,
  () => import('@omni/components/sample/delivery-request-new/new-sample-delivery-request.component').then(m => m.NewSampleDeliveryRequestComponent)
);

registerComponent(
  PageName.SampleDeliveryRequestDetailComponent,
  () => import('@omni/components/sample/delivery-request-detail/sample-delivery-request-detail.component').then(m => m.SampleDeliveryRequestDetailComponent)
);

registerComponent(
  PageName.ContactCallPlanListComponent,
  () => import('@omni/components/contact/contact-call-plan-list/contact-call-plan-list').then(m => m.ContactCallPlanListComponent)
);
